import { defaultMsg as t } from "../internal/default-msg.js";
var m = t;
export { m as msg };